export default {
  columnGap: 20,
  font: 'HelveticaNeue',
  lineHeight: 1
}

export const header = {
  fontSize: 24,
  bold: false,
  alignment: 'center'
};

export const subHeader = {
  fontSize: 10,
  alignment: 'center'
}

export const headerLink = {
  fontSize: 9,
  color: '#2477AB',
  decoration: 'underline',
  margin: [0, 15, 0, 0],
  alignment: 'center'
};

export const sectionTitle = {
  fontSize: 18,
  color: '#EC6B29'
};

export const cardSectionTitle = {
  ...sectionTitle,
  margin: [0, 10],
}

export const cardTitleIdx = {
  color: '#ff6000',
  bold: false,
  fontSize: 14,
}

export const cardTitle = {
  fontSize: 18,
  color: '#23233F',
  lineHeight: 1
}

export const cardTitleBig = {
  ...cardTitle,
  fontSize: 14
};

export const cardSubTitle = {
  fontSize: 10,
  color: '#23233F'
}

export const cardDescription = {
  fontSize: 10
}

export const cardRowTitle = {
  fontSize: 12,
  bold: false,
  margin: [0, 10]
};

export const cardRowValue = {
  fontSize: 14,
  bold: false,
  normal: true,
  color: '#23233F',
  alignment: 'right',
  margin: [0, 10]
};

export const cardRowEyebrow = {
  fontSize: 7,
  bold: false,
  margin: [0, 10, 0, 5]
};

export const cardRowNumber = {
  fontSize: 26,
  bold: false,
  margin: [0, 0, 0, 0]
};

export const cardGridTitle = {
  fontSize: 10,
  color: '#23233F',
  margin: [0, 15, 0, 0] // https://github.com/bpampuch/pdfmake/issues/74#issuecomment-184088189
}

export const cardGridValue = {
  fontSize: 14,
  bold: false,
  normal: false,
  light: true,
  color: '#23233F',
  margin: [0, 4, 0, 0]
}

export const cardGridValueBig = {
  ...cardGridValue,
  fontSize: 18
}

export const disclaimer = {
  fontSize: 7,
  color: '#4d4d4d',
}

export const disclaimerT = {
  fontSize: 9,
  bold: true,
  color: '#000000',
  margin: [0, 0, 0, 10],
};

export const disclaimerP = {
  fontSize: 9,
  bold: false,
  color: '#4d4d4d',
  lineHeight: 1.2,
  margin: [0, 0, 0, 5]
};

export const disclaimerA = {
  fontSize: 6
}
